const menu = [
  {
    title: 'DECA',
    name: 'DECA',
    icon: 'fas fa-building'
  },
  {
    title: 'Obras Particulares',
    name: 'obrasParticulares',
    icon: 'fas fa-building'
  },
  {
    title: "Serviços Empresas",
    name: "servicoEmpresa",
    icon: "fas fa-file-alt"
  },
  {
    title: "Serviços Rede SIM",
    name: "RedeSIM",
    icon: "fas fa-sitemap"
  }
];

export { menu };
